// extracted by mini-css-extract-plugin
export default {"leaveUsAMessageContainer":"LeaveUsAMessage_leaveUsAMessageContainer__ox0Ql"};